import { TIPO_APOLICE } from '../../../../../../common/constant/tipo_apolice';
import Modal from '../../../../../components/Modal.vue';
import reportsApi from '../../../../../services/reports.api';
import functions from '../../../../../utils/functions';
import notify from '../../../../../utils/notify';

const DEFAULT_PAGINATION_ITEMS_PER_PAGE = 10;

export default {
  props: ['showModal', 'title', 'filters', 'totalPolicies'],
  components: { Modal },
  data() {
    return {
      TIPO_APOLICE,
      active: false,
      policies: [],
      currentPage: 1,
      totalPages: 1,
      pageSize: DEFAULT_PAGINATION_ITEMS_PER_PAGE,
    };
  },
  watch: {
    async currentPage() {
      await this.fetchData();
    },
    async showModal() {
      this.active = this.showModal;
      if (!this.showModal) {
        this.currentPage = 1;
        return;
      }
      await this.fetchData();
    },
  },
  computed: {
    screenWidth() {
      return window.innerWidth;
    },
  },
  methods: {
    formatMoney(value) {
      return functions.formataReal(value);
    },
    formatDate(date) {
      if (!date) return '';
      return functions.formataDataMomentJS(date);
    },
    closeModal() {
      this.$emit('closeModal');
    },
    async fetchData() {
      this.$vs.loading();
      try {
        const payload = {
          ...this.filters,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
        };
        this.policies = await reportsApi.getFinancialReportDetailed(payload);
        this.totalPages = Math.ceil(this.totalPolicies / this.pageSize);
        this.$vs.loading.close();
      } catch {
        notify.notifyFail(this.$vs, 'Erro ao buscar dados financeiros');
        this.$vs.loading.close();
      }
    },
    getDueDateLimit(dueDate, dueDateDaysLimit) {
      if (!dueDate) return '';
      if (!dueDateDaysLimit) return functions.formataDataMomentJS(dueDate);
      const dueDateObj = new Date(dueDate);
      const dueDateLimitObj = dueDateObj.setUTCDate(
        dueDateObj.getUTCDate() + dueDateDaysLimit,
      );
      return functions.formataDataMomentJS(dueDateLimitObj);
    },
  },
};
